import { addEventListenerLive } from "./helpers/events";
const $ = require("jquery");
document.addEventListener('DOMContentLoaded', () => {
    addEventListenerLive('click', 'a.hide-review-notice-soft', (e) => {
        e.preventDefault();
        let notice = e.target.closest('.ac-notice');
        notice.querySelector('.info').remove();
        notice.querySelector('.help').style.display = 'block';
        $.post(ajaxurl, JSON.parse(notice.dataset.dismissibleCallback));
    });
    addEventListenerLive('click', 'a.hide-review-notice', (e) => {
        e.preventDefault();
        e.target.closest('.ac-notice').querySelector('.notice-dismiss').dispatchEvent(new Event('click'));
    });
});
